import styled from "styled-components";

const Title = styled.p`
  ${(props) =>
    props.hover &&
    `
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    } 
  `};

  ${(props) =>
    props.overflow &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  `}
  line-height: initial;
  font-size: ${(props) => props.size || "16px"};
  font-weight: bold;
  height: ${(props) => props.height || "fit-content"};
  max-width: ${(props) => props.maxWidth || "100%"};
  max-height: ${(props) => props.maxHeight || "100%"};
  text-align: ${(props) => props.textAlign || "start"};
  width: ${(props) => props.width || "fit-content"};
  text-transform: ${(props) => props.textTransform || "none"};
`;

export default Title;
